export const getCategoriesExpanses = state => state.categories.expansesArr;
export const getCategoriesIncome = state => state.categories.incomeArr;
